import { forwardRef, type SelectHTMLAttributes } from "react";
import { cn } from "@/lib/utils";

/**
 * Small caption above a form control — the admin forms' one label style.
 * Wrapping the control associates the caption with it (screen readers,
 * click-to-focus) without threading ids through.
 */
export function Field({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) {
  return (
    <label className="block">
      <span className="text-xs text-muted-foreground">{label}</span>
      {children}
    </label>
  );
}

export type SelectProps = SelectHTMLAttributes<HTMLSelectElement>;

/** Native select styled to sit beside Input. */
export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, ...props }, ref) => (
    <select
      ref={ref}
      className={cn(
        "block rounded border bg-background px-2 py-1 text-sm",
        className,
      )}
      {...props}
    />
  ),
);
Select.displayName = "Select";
